import { getFundamentalValue } from '../../../../utils/fundamentals';
import DateTime from '../../../common/DateTime';

const mdash = '\u2014';

const WeeklyMarginDate = ({ fundamentals }) => {
  const utcDateText = getFundamentalValue(
    fundamentals,
    'weeklyMarginPurchases',
    'reportingDate'
  );
  if (!utcDateText) {
    return mdash;
  }

  return <DateTime format="MM/DD" value={utcDateText} />;
};

export default WeeklyMarginDate;
